<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <div
        data-slot="dialog-header"
        :class="cn('sticky flex flex-col gap-2 p-5 text-center sm:text-left', props.class)"
    >
        <slot />
    </div>
</template>
